import { render } from "./elem-select.vue?vue&type=template&id=20d46134&ts=true"
import script from "./elem-select.vue?vue&type=script&lang=ts"
export * from "./elem-select.vue?vue&type=script&lang=ts"

import "./elem-select.vue?vue&type=style&index=0&id=20d46134&lang=less"

import exportComponent from "/usr/local/share/applications/yushifu-shop-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__